import { FaArrowCircleLeft } from '@react-icons/all-files/fa/FaArrowCircleLeft';
import { useContext } from 'react';

import { Link } from 'components';
import { Col, Container, Row } from 'components/GridV2';
import { SmallText } from 'components/Typography';
import { LocaleContext } from 'components/rebrand/Layout';

const LearnBreadCrumb = () => {
  const locale = useContext(LocaleContext);
  return (
    <Container className="mb-16 px-30 xs:px-0 md:mb-32">
      <Row className="flex-wrap">
        <Col>
          <Link
            aria-label={{ en: `Back to learn`, fr: `Retour au blog` }[locale]}
            className="inline-flex cursor-pointer items-center font-bold text-blue-alt no-underline hover:text-blue-deep"
            to={'/learn/'}
          >
            <FaArrowCircleLeft className="mr-8 -translate-y-2" />
            <SmallText className="mb-0 font-bold">{{ en: `Back to learn`, fr: `Retour au blog` }[locale]}</SmallText>
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default LearnBreadCrumb;
